import React from "react";

/**
 * Check value for hyperlinks and convert them appropriately to
 * displayable hyperlinks.
 * @param value - String which may contain hyperlinks
 * @returns React compatible string.
 */
const displayHyperlinks = value => {
  let myData = value.replace(/(https?:\/\/[A-Za-z0-9./-]+)/g, "<a target=_blank href=\"$1\">$1</a>");
  myData = myData.replace(/(?<= )([A-Za-z0-9./-]+@[A-Za-z0-9./-]+)(?=(.$|. |$))/g, "<a href=\"mailto:$1\">$1</a>")
  if (myData !== value) {
    // eslint-disable-next-line react/no-danger
    return (<div className="content" dangerouslySetInnerHTML={{ __html: myData }} />);
  }
  return value;
}

export default displayHyperlinks;


// WEBPACK FOOTER //
// ./src/components/grids/ItemDescInfoGrid/displayHyperlinks.jsx